<template>
  <el-upload
    action
    :on-remove="handleRemove"
    :http-request="upload"
    :file-list="explainFileList"
    :on-preview="handlePreview"
    multiple
  >
    <!--  v-has-permission="permission"  -->
    <el-button size="small" :icon="icon">{{ name }}</el-button>
  </el-upload>
</template>

<script>
import { personAppenAddFile, wordUpload, ResumeParser, deletePersonBypercode } from '@/api/common'
import axios from 'axios'
export default {
  props: {
    personnelCode: {
      type: String
    },
    icon: {
      type: String
    },
    name: {
      type: String
    },
    lookUrl: {
      type: String
    },
    saveUrl: {
      type: String
    },
    personCode: {
      type: String
    },
    permission: {
      type: String
    }
  },
  data() {
    return {
      fileList: [],
      // fileArray: [],
      explainFileList: []
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    }
  },
  watch: {
    lookUrl: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.updateExplainFileList()
        }
      },
      immediate: true,
      deep: true
    },
    name: {
      handler: function (newVal, oldVal) {
        console.log(newVal, 'newVal')
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    updateExplainFileList() {
      if (this.lookUrl) {
        let name = this.lookUrl.substring(this.lookUrl.lastIndexOf('/') + 1)

        name = name.split('?')[0]

        this.explainFileList.push({
          name,
          url: this.lookUrl
        })
      } else {
        this.explainFileList = []
      }
    },
    handleRemove() {
      this.explainImgList = []
    },
    async upload(file) {
      this.explainFileList = []
      const form = new FormData()
      form.append('file', file.file)
      // form.append('Authorization', this.Authorization)
      console.log(this.personnelCode)
      if (this.personnelCode) {
        // 修改上传简历
        const { data1: res1 } = await deletePersonBypercode({ preCode: this.personnelCode })
        console.log(res1)
        form.append('personCode', this.personnelCode)
        const { data: res } = await ResumeParser(form, this.personnelCode)
        if (res.resultCode === 200) {
          this.$emit('fileClicks')
          this.$message.success('上传成功')
          // this.$emit('update:lookUrl', res.data.fileLook[0])
          // this.$emit('update:saveUrl', res.data.fileAddr[0])
        } else {
          this.$message.error('上传失败')
        }
      } else {
        // 上传简历
        const personnelCode = ''
        form.append('personCode', personnelCode)
        const { data: res } = await ResumeParser(form)
        if (res.resultCode === 200) {
          this.$emit('fileClicks')
          //  返回code  在候选列表添加
          this.$emit('personCode', res.data.message)
          this.$message.success('上传成功')
          // this.$emit('update:lookUrl', res.data.fileLook[0])
          // this.$emit('update:saveUrl', res.data.fileAddr[0])
        } else {
          this.$message.error('上传失败')
        }
      }
    },
    clear() {
      this.explainFileList = []
    },
    handlePreview() {
      const url = this.saveUrl
      axios({
        method: 'GET',
        url: process.env.VUE_APP_BASE_API + 'upload/uploadFile',
        params: { urlStr: url },
        responseType: 'blob',
        headers: {
          // 设置请求头
          token: this.Authorization
        }
      })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: `application/msword`
          })
          let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          a.download = this.saveUrl.substring(this.saveUrl.lastIndexOf('/') + 1) //指定下载文件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
          document.body.removeChild(a) //释放标签
        })
        .catch(() => {
          //this.$message.error('文件下载失败')
        })
    }
  }
}
</script>
